import { useEffect } from "react";
import u from "./ui.module.css";

export default function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  size = "md",
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className={u.overlay}
      role="dialog"
      aria-modal="true"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
    >
      <div
        className={`${u.modal} ${
          size === "xl" ? u.modalXl : size === "lg" ? u.modalLg : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {title ? (
          <div className={u.modalHeader}>
            <h2 className={u.modalTitle}>{title}</h2>
            <button
              type="button"
              className={u.modalClose}
              onClick={onClose}
              aria-label="Закрыть"
            >
              ×
            </button>
          </div>
        ) : null}
        <div className={u.modalBody}>{children}</div>
        {footer ? <div className={u.modalFooter}>{footer}</div> : null}
      </div>
    </div>
  );
}
